import { useEffect, useCallback, useState, useContext } from "react";
import EditProductUI from "./EditProductUI";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { IProduct } from "src/types/global";
import { productService } from "@services/ProductService";
import { GlobalAlertContext } from "@providers/GlobalAlertProvider";
import { getCleanCurrency, getNumberCurrency } from "@utils/utils";
const EditProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: {
      errors
    }
  } = useForm<IProduct>({});
  const [product, setProduct] = useState<IProduct>({
    id: -1,
    reference: "N/A",
    description: "...",
    price: "0",
    status: 1
  });
  const [loadingData, setLoadingData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const {
    setGlobalAlertMessage,
    setGlobalAlertSeverity,
    showGlobalAlert,
    hiddenGlobalAlert
  } = useContext(GlobalAlertContext);
  const onSubmit = async (newProduct: IProduct) => {
    try {
      setGlobalAlertSeverity("success");
      setGlobalAlertMessage("!Listo! El producto ha sido actualizado correctamente");
      setIsLoading(true);
      newProduct.price = String(getNumberCurrency(newProduct.price));
      const payload = {
        ...product,
        ...newProduct
      };
      const res = await productService.put(payload);
      navigate(`/productos/${product.id}`, {
        state: {
          showAlert: true,
          product: {
            ...res.data
          }
        }
      });
      showGlobalAlert();
    } catch {
      hiddenGlobalAlert();
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };
  const getProduct = useCallback(async (id: number, withState: boolean = false) => {
    try {
      if (!withState) {
        setLoadingData(true);
      }
      const res = await productService.get(id);
      const productDB = res.data;
      setProduct(productDB);
      setValue("description", productDB.description);
      setValue("reference", productDB.reference);
      setValue("price", getCleanCurrency(productDB.price));
    } catch (error) {
      setGlobalAlertSeverity("error");
      setGlobalAlertMessage("El producto no existe");
      navigate("/productos", {
        state: {
          showAlert: true
        }
      });
      setTimeout(() => {
        showGlobalAlert();
      }, 300);
    } finally {
      setLoadingData(false);
    }
  }, [navigate, setGlobalAlertSeverity, setGlobalAlertMessage, showGlobalAlert, setValue]);
  useEffect(() => {
    const id = Number(location.pathname.split("/").reverse()[0]);
    const routeState: IProduct = location.state;
    if (id === routeState?.id) {
      setProduct(routeState);
      setValue("description", routeState.description);
      setValue("reference", routeState.reference);
      setValue("price", getCleanCurrency(routeState.price));
      return;
    }
    getProduct(id, false);
  }, [getProduct, location, setValue]);
  return <EditProductUI register={register} onSubmit={handleSubmit(onSubmit)} loadingData={loadingData} isLoading={isLoading} showError={showError} errors={errors} closeError={() => setShowError(false)} handleCancelClick={() => navigate("/productos")} />;
};
export default EditProduct;